module.exports = __webpack_public_path__ + "static/media/project_AI_icon.c8352b83.svg";